import { b as __assign } from '../../../../_tslib-7a01aab4.js';
import React, { memo } from 'react';
import { LogoLoader } from '../logo/index.js';
import { Progress } from '../progress/index.js';
import { Provider } from '../provider/index.js';
import { LoaderContent } from '../loader-content/index.js';

var LoadingComp = function (_a) {
    var logo = _a.logo, providerLogo = _a.providerLogo, progress = _a.progress, withoutProviderRenderer = _a.withoutProviderRenderer, withoutProgressRenderer = _a.withoutProgressRenderer;
    return (React.createElement(LoaderContent, __assign({}, {
        providerRenderer: withoutProviderRenderer ? null : React.createElement(Provider, { providerLogo: providerLogo }),
        progressRenderer: withoutProgressRenderer ? null : React.createElement(Progress, { progress: progress }),
    }, { logoRenderer: React.createElement(LogoLoader, { src: logo }) })));
};
LoadingComp.displayName = 'Loading';
var Loading = memo(LoadingComp);

export { Loading };
